/* projects/speaker-platform/src/app/pages/messaging/messaging.component.scss */
.messagerie {
  max-height: 780px;
}
.messagerie .left-panel {
  border-right: 1px solid #cccccc;
  max-height: 750px;
  overflow-y: scroll;
}
/*# sourceMappingURL=messaging.component-LFMVVBQD.css.map */
